export const PlannerPopoverScreen = {
  Settings: 0,
  ConnectAccount: 1,
  ConnectedCalendars: 2,
  CustomView: 3,
  DisconnectAccount: 4,
  Feedback: 5,
  AdjustCalendarView: 6,
  DisconnectAccountSelection: 7,
  ReconnectAccount: 8,
  SelectPrimaryAccount: 9,
  ManageAccounts: 10,
  AccountDetails: 11,
};

export type PlannerPopoverScreenType =
  (typeof PlannerPopoverScreen)[keyof typeof PlannerPopoverScreen];
